import { Quote } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionTitle } from "@/components/Shared";
import { F1_AWARENESS } from "@/data/site";

export const F1Section = () => {
  return (
    <section data-testid="f1-section" className="relative overflow-hidden bg-obsidian py-24 md:py-32">
      <span className="pointer-events-none absolute -left-4 top-6 select-none font-anton text-[20vw] leading-none text-white/[0.03] md:text-[13vw]">
        F1
      </span>
      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
        <SectionTitle eyebrow="ENDORSED AT THE HIGHEST LEVEL" title="The World Is Watching" />
        <div className="mt-6 flex max-w-3xl items-start gap-3">
          <Quote className="mt-1 h-8 w-8 flex-shrink-0 text-kbyellow" />
          <p className="text-lg leading-relaxed text-white/70">
            {F1_AWARENESS.lead}
          </p>
        </div>
        <p className="mt-4 max-w-3xl font-display text-2xl tracking-wide text-kbcyan">
          “{F1_AWARENESS.articleTitle}” — The Tribune
        </p>

        <StaggerGroup className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {F1_AWARENESS.people.map((p) => (
            <StaggerItem key={p.name}>
              <div className="group h-full overflow-hidden rounded-xl border border-white/10 bg-[#0A0A0A] transition-all hover:-translate-y-2 hover:border-kbyellow/50">
                <div className="flex h-60 items-center justify-center overflow-hidden bg-black/50">
                  <img src={p.img} alt={p.name} className="max-h-full max-w-full object-contain" />
                </div>
                <div className="p-5">
                  <h3 className="font-display text-xl leading-tight tracking-wide text-white">{p.name}</h3>
                  <p className="mt-1 text-sm text-kbcyan">{p.role}</p>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};

export default F1Section;
